import api from './api';

// Ad-hoc read-only SQL sent to a project's SyncConnect (Admin › Platform › SyncConnect, superadmin) — V576.
const syncConnectQueryService = {
    list:     (params) => api.get('/admin/syncconnect-queries', { params }),
    get:      (id)     => api.get(`/admin/syncconnect-queries/${id}`),
    projects: ()       => api.get('/admin/syncconnect-queries/projects'),
    submit:   (body)   => api.post('/admin/syncconnect-queries', body),
    // Soft delete (V578) — hidden from the list, kept as the audit; a still-queued query is taken off the queue.
    remove:   (id)     => api.delete(`/admin/syncconnect-queries/${id}`),

    // THE LIBRARY (V585) — saved queries, not tied to a project; the palette on the right of the screen.
    library:        ()         => api.get('/admin/syncconnect-queries/library'),
    saveToLibrary:  (body)     => api.post('/admin/syncconnect-queries/library', body),
    updateLibrary:  (id, body) => api.put(`/admin/syncconnect-queries/library/${id}`, body),
    removeLibrary:  (id)       => api.delete(`/admin/syncconnect-queries/library/${id}`),

    // STATUS QUERIES (V613) — the checks every SyncConnect runs once a minute; the Status Queries tab.
    statusQueries:      ()         => api.get('/admin/syncconnect-status-queries'),
    statusResults:      (params)   => api.get('/admin/syncconnect-status-queries/results', { params }),
    createStatusQuery:  (body)     => api.post('/admin/syncconnect-status-queries', body),
    updateStatusQuery:  (id, body) => api.put(`/admin/syncconnect-status-queries/${id}`, body),
    removeStatusQuery:  (id)       => api.delete(`/admin/syncconnect-status-queries/${id}`),
    // id 'draft' tests the query in the body without saving it; the answer arrives on the Queries tab.
    testStatusQuery:    (id, body) => api.post(`/admin/syncconnect-status-queries/${id || 'draft'}/test`, body),
    // The test's answer, judged against { check_op, expected_value } — polled by the editor until it is in.
    statusTestResult:   (id, params) => api.get(`/admin/syncconnect-status-queries/${id || 'draft'}/test`, { params }),
};

export default syncConnectQueryService;
